import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Beauty = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M29.92,38.272c0.1,0.14 0.175,0.235 0.295,0.46c0.24,0.545 -0.005,1.18 -0.55,1.42c-0.545,0.24 -1.18,-0.005 -1.42,-0.55c0.015,0.02 -0.035,-0.09 -0.07,-0.145c-0.03,-0.07 -0.09,-0.14 -0.135,-0.21c-0.105,-0.135 -0.22,-0.275 -0.355,-0.395c-0.12,-0.135 -0.285,-0.23 -0.43,-0.35c-0.165,-0.09 -0.325,-0.2 -0.505,-0.28c-0.715,-0.325 -1.565,-0.505 -2.445,-0.495c-0.22,-0.015 -0.44,0.005 -0.665,0.02c-0.22,0.02 -0.445,0.025 -0.67,0.05c-0.445,0.08 -0.9,0.13 -1.35,0.24c-0.445,0.12 -0.9,0.21 -1.345,0.355l-1.33,0.445l-0.03,0.01c-0.225,0.075 -0.47,-0.045 -0.545,-0.27c-0.07,-0.21 0.03,-0.435 0.225,-0.525l1.325,-0.615c0.445,-0.2 0.915,-0.355 1.375,-0.535c0.465,-0.17 0.955,-0.28 1.435,-0.425c0.245,-0.05 0.495,-0.095 0.745,-0.14c0.25,-0.045 0.5,-0.095 0.76,-0.105c1.02,-0.125 2.11,-0.05 3.18,0.295c0.27,0.08 0.53,0.21 0.79,0.325c0.245,0.15 0.51,0.275 0.74,0.465c0.24,0.17 0.465,0.375 0.675,0.595c0.1,0.12 0.205,0.225 0.3,0.36Zm13.621,-19.486c0.705,0.69 0.575,2.135 -0.23,2.58l-2.825,3.27c-3.931,4.551 -9.536,7.421 -15.546,7.646c-0.31,0.015 -0.63,0.02 -0.94,0.02c-0.31,0 -0.625,-0.01 -0.94,-0.02c-6.01,-0.23 -11.615,-3.095 -15.546,-7.646l-2.825,-3.27c-0.805,-0.445 -0.935,-1.895 -0.23,-2.58l8.881,-8.675c1.61,-1.57 3.505,-2.355 5.405,-2.355l0,2.5c-1.29,0 -2.555,0.57 -3.655,1.645l-6.886,6.72c1.6,0.21 3.326,0.565 5.121,0.94c3.93,0.82 7.99,1.665 10.29,0.715c0.25,-0.105 0.53,-0.105 0.78,0.005c1.91,0.83 5.375,0.125 9.045,-0.625c2.085,-0.425 4.221,-0.855 6.311,-1.075l-6.841,-6.68c-1.105,-1.075 -2.37,-1.645 -3.66,-1.645c-1.24,0 -2.465,0.53 -3.545,1.535c-0.48,0.45 -1.09,0.675 -1.705,0.675c-0.61,0 -1.225,-0.225 -1.705,-0.675c-1.075,-1.005 -2.3,-1.535 -3.545,-1.535l0,-2.5c1.835,0 3.67,0.735 5.25,2.21c1.58,-1.475 3.415,-2.21 5.25,-2.21c1.9,0 3.8,0.785 5.41,2.355l8.881,8.675Zm-4.945,4.215l2.165,-2.5c-2.24,0.165 -4.606,0.645 -6.916,1.115c-3.785,0.77 -7.365,1.5 -9.85,0.65c-0.895,0.3 -1.91,0.42 -3.015,0.42c-2.435,0 -5.28,-0.59 -8.06,-1.17c-2.02,-0.42 -3.956,-0.825 -5.656,-0.995l2.14,2.48c3.556,4.116 8.566,6.586 13.746,6.781c0.285,0.01 0.57,0.015 0.85,0.015c0.285,0 0.57,-0.005 0.85,-0.015c5.18,-0.195 10.19,-2.665 13.746,-6.781Z" fill={fill} />
    </svg>
  );
};

Beauty.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

Beauty.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
